import { FC } from 'react';

import { useFieldArray, useFormContext } from 'react-hook-form';

import { BasicDepartmentInfo } from 'models/Department';

import { PathwayCategory } from 'views/Pages/PathwayBuilder/PathwayEditorView/PathwayCategory';
import {
  CategoryFormField,
  PathwayEditorFormFields
} from 'views/Pages/PathwayBuilder/PathwayEditorView/PathwayEditorView.types';

interface Props {
  institutions: BasicDepartmentInfo[];
}

export const PathwayCategories: FC<Props> = ({ institutions }) => {
  const { control } = useFormContext<PathwayEditorFormFields>();

  const {
    fields: categories,
    remove: removeCategory,
    insert: insertCategory
  } = useFieldArray<PathwayEditorFormFields, 'categories'>({
    control,
    name: 'categories'
  });

  const onRemoveCategory = (index?: number | number[]) => removeCategory(index);

  const onInsertCategory = (index: number, value: CategoryFormField) =>
    insertCategory(index, value);

  return (
    <>
      {categories.map((category: CategoryFormField, index) => (
        <PathwayCategory
          key={category.categoryId}
          index={index}
          path={`categories.${index}`}
          category={category}
          onRemoveCategory={onRemoveCategory}
          onInsertCategory={onInsertCategory}
          institutions={institutions}
        />
      ))}
    </>
  );
};
